// extracted by mini-css-extract-plugin
export var loadingSpinner = "_55-1";
export var standaloneTable = "_55-0";